module.exports = __webpack_public_path__ + "static/media/planet-level15.383008a7.png";